var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowExit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#F0F5F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5231 5.67676L6 5.67676L6 34.3226L23.5231 34.3226L23.5231 5.67676Z",
    fill: "#D3F8F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1871 5.67676L24.1871 13.3156L23.5231 13.3156L23.5231 6.02051L6.66403 6.02051L6.66403 33.9788L23.5231 33.9788L23.5231 26.6837H24.188L24.188 34.3226C24.188 34.5126 24.0395 34.6663 23.856 34.6663L6.33202 34.6663C6.14849 34.6663 6 34.5126 6 34.3226L6 5.67676C6 5.48674 6.14849 5.33301 6.33202 5.33301L23.8551 5.33301C24.0386 5.33301 24.1871 5.48674 24.1871 5.67676Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3962 20.3425L11.3962 19.655L32.7291 19.655L27.7627 14.5121L28.2312 14.027L34 19.9987L28.2312 25.9714L27.7627 25.4844L32.7291 20.3425L11.3962 20.3425Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowExit);
export default __webpack_public_path__ + "static/media/ic-arrow-exit.f39c4dad675fedad775815ccaf75f787.svg";
export { ForwardRef as ReactComponent };